<template>
  <div class="create-live-standard container">
    <el-form ref="form" :model="form" :rules="rules" size="small">
      <create-choice
        :contentArr="['直播带货', '通投广告', '专业推广']"
        @onChange="show = true"
      />

      <choose-account title="请选择要开播的抖音号" type="live" />

      <delivery-setting :form="form" />

      <target-package :form="form" />

      <div style="position: relative">
        <div class="creative-module">
          <p class="level-1">请为直播间添加创意</p>
          <p class="level-2">创意形式</p>
          <el-radio-group v-model="form.creativeForm" size="medium">
            <el-radio-button label="直播间画面"></el-radio-button>
            <el-radio-button label="视频"></el-radio-button>
          </el-radio-group>
          <p class="tips" v-show="form.creativeForm == '直播间画面'">
            <i class="el-icon-info"></i
            >直播期间，系统将推广直播间画面，并展示相关推广卡片。
          </p>

          <div v-show="form.creativeForm == '视频'">
            <div class="level-2">
              创意类型
              <div class="bulb-wrapper" @click="showCreativeType = true">
                <el-image
                  class="icon"
                  :src="require('@/assets/images/simulation/icon_bulb.png')"
                  fit="cover"
                ></el-image>
                <span class="bulb-text">了解详情</span>
              </div>
            </div>
            <el-radio-group v-model="form.creativeType" size="medium">
              <el-radio-button label="程序化创意" disabled></el-radio-button>
              <el-radio-button label="自定义创意"></el-radio-button>
            </el-radio-group>
          </div>

          <add-video
            v-if="form.creativeForm == '视频'"
            :videoNum="videoNum"
            :videoMax="10"
            title="添加创意内容"
            rightBtn="直播剪辑工具"
            @onConfirm="onConfirm"
          />

          <div class="auto-checkbox">
            <el-checkbox v-model="form.autoLaunch"
              >开启高光快投，一键精选直播片段并自动投放
            </el-checkbox>
            <div class="bulb-wrapper" @click="showAutoLaunch = true">
              <el-image
                class="icon"
                :src="require('@/assets/images/simulation/icon_bulb.png')"
                fit="cover"
              ></el-image>
              <span class="bulb-text">了解详情</span>
            </div>
          </div>

          <div class="switch-bottom" v-if="form.creativeForm == '视频'">
            <p class="title-name">
              抖音主页隐藏视频
              <el-popover placement="top" trigger="hover">
                <p style="font-size: 12px">
                  隐藏后，用户在你的选择的抖音号的主页看不到新增的视频创意
                </p>
                <p style="margin-top: 5px; color: #909399; font-size: 12px">
                  注意：计划自动生成的视频创意将默认隐藏，不跟随设置变化
                </p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </p>
            <el-radio-group v-model="form.hide" size="medium">
              <el-radio-button label="隐藏"></el-radio-button>
              <el-radio-button label="不隐藏"></el-radio-button>
            </el-radio-group>
          </div>
        </div>

        <div class="creative-preview">
          <div class="title-section">
            <p class="title-text">
              {{
                form.creativeForm == "直播间画面"
                  ? "直播间画面预览"
                  : "创意预览"
              }}
            </p>
            <div class="change-arrow" v-show="form.creativeForm == '视频'">
              <i class="el-icon-back icon mr"></i>
              <i class="el-icon-right icon"></i>
            </div>
          </div>
          <div class="component-preview-wrapper">
            <div class="live" v-if="form.creativeForm == '直播间画面'">
              <div class="creative-detail-info">
                <el-image
                  class="avatar"
                  src="https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg"
                  fit="cover"
                ></el-image>
                <span class="account-name">抖音账号123</span>
              </div>
            </div>
            <div class="video" v-else>
              <el-image
                v-if="videoNum > 0"
                class="cover"
                :src="require('@/assets/images/simulation/live_cover.png')"
                fit="cover"
              ></el-image>
              <div class="not-support" v-else>
                <el-image
                  style="width: 100px; height: 72px"
                  :src="require('@/assets/images/simulation/empty.png')"
                  fit="cover"
                ></el-image>
                <p class="empty-text">请先选择一个创意视频</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <creative-label :form="form" :isStandard="true" />

      <form-bottom
        :form="form"
        :show="show"
        @onSubmit="onSubmit"
        @onClose="show = false"
        @onCancel="show = true"
      >
        <div class="live-show-promise-notice">
          <el-checkbox v-model="agree" disabled></el-checkbox>
          <span>
            我已阅读并同意
            <a
              href="https://qianchuan.jinritemai.com/agreement/live-show-argeement"
              target="_blank"
              rel="noopener noreferrer"
              >《直播间引流承诺函》</a
            >
          </span>
        </div>
      </form-bottom>
    </el-form>

    <tips-drawer
      :showAutoLaunch="showAutoLaunch"
      :showCreativeType="showCreativeType"
      @onClose="
        showAutoLaunch = false;
        showCreativeType = false;
      "
    />
  </div>
</template>

<script>
import AddVideo from "../components/addVideo.vue";
import ChooseAccount from "../components/chooseAccount.vue";
import createChoice from "../components/createChoice.vue";
import CreativeLabel from "../components/creativeLabel.vue";
import FormBottom from "../components/formBottom.vue";
import TargetPackage from "../components/targetPackage.vue";
import TipsDrawer from "../components/tipsDrawer.vue";
import DeliverySetting from "./deliverySetting.vue";
import { submit } from "@/api/chapterMock";

export default {
  components: {
    createChoice,
    ChooseAccount,
    FormBottom,
    AddVideo,
    CreativeLabel,
    TipsDrawer,
    TargetPackage,
    DeliverySetting,
  },
  data() {
    var checkBudget = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error("预算不少于300元，不超过9999999.99元，请正确输入")
        );
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 300 || value > 9999999.99) {
          callback(
            new Error("预算不少于300元，不超过9999999.99元，请正确输入")
          );
        } else {
          callback();
        }
      }
    };
    var checkBid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("出价不少于0.1元，不超过10000元"));
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 0.1 || value > 10000) {
          callback(new Error("出价不少于0.1元，不超过10000元"));
        } else {
          callback();
        }
      }
    };
    return {
      show: false,
      form: {
        mode: "控成本投放",
        action: "进入直播间",
        limit: false,
        deliverySpeed: "尽快投放",
        optimizeOrder: false,
        budget: null,
        bid: null,
        directionSetting: "新建定向",
        dateType: "从今天起长期投放",
        startTime: "",
        endTime: "",
        during: 2,
        timeIntervalType: "不限",
        adName: "直播",
        adGroup: "广告1组",
        directional: "自定义人群",
        audience: {
          directionalType: "新建定向",
          region: "不限",
          regionArr: [],
          audienceType: "正在该地区的用户",
          sex: "不限",
          age: [],
          interest: "不限",
          behavioralInterest: {
            scene: [],
            day: "30天",
            behaviorArr: [],
            interestArr: [],
          },
          talent: "不限",
          network: [],
          platform: "不限",
          morePopulation: "不限",
          autoExtend: "不启用",
          extendArr: [],
        },
        creativeForm: "直播间画面",
        autoLaunch: false,
        hide: "隐藏",
        creativeClass: "",
        creativeLabels: [],
        creativeType: "自定义创意",
      },
      rules: {
        budget: {
          validator: checkBudget,
          trigger: "blur",
        },
        bid: {
          validator: checkBid,
          trigger: "blur",
        },
      },
      videoNum: 0,
      agree: true,
      showAutoLaunch: false,
      showCreativeType: false,
    };
  },
  methods: {
    onConfirm(val) {
      this.videoNum = val;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // console.log({ ...this.form, ...JSON.parse(this.$route.query.form) });
          this.$confirm(`确定要提交吗？`)
            .then(() => {
              const classChapterId = localStorage.getItem("mockChapterId");
              submit({
                classChapterId,
                content: JSON.stringify({
                  ...this.form,
                  ...JSON.parse(this.$route.query.form),
                }),
              }).then((res) => {
                this.$alert("提交成功", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    window.close();
                  },
                });
              });
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.create-live-standard {
  padding-top: 32px;
  padding-left: 50px;
  text-align: left;
  .level-1 {
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 5px;
    font-size: 16px;
    color: #c0c4cc;
    vertical-align: middle;
    cursor: pointer;
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
  .bulb-wrapper {
    display: inline-block;
    margin-left: 5px;
    cursor: pointer;
    &:hover {
      .bulb-text {
        visibility: visible;
        opacity: 1;
      }
    }
    .icon {
      vertical-align: -5px;
    }
    .bulb-text {
      display: inline-block;
      padding-right: 8px;
      font-size: 12px;
      font-weight: 400;
      line-height: 26px;
      color: #ee8c10;
      height: 26px;
      border-radius: 19px;
      overflow: hidden;
      background: radial-gradient(
          42.91% 103.85% at 82.93% -23.08%,
          rgba(255, 126, 71, 0.15) 0,
          hsla(0, 0%, 100%, 0) 100%
        ),
        linear-gradient(
          268.85deg,
          #fef7d8 23.21%,
          rgba(254, 247, 216, 0) 99.01%
        );
      vertical-align: middle;
      transition: all 0.3s ease;
      visibility: hidden;
      opacity: 0;
    }
  }
  .auto-checkbox {
    margin-top: 18px;
    ::v-deep .el-checkbox {
      .el-checkbox__inner {
        width: 16px;
        height: 16px;
        &:hover {
          border-color: #333;
        }
        &::after {
          left: 5px;
        }
      }
      .el-checkbox__label {
        padding-left: 5px;
        line-height: 20px;
        font-weight: 600;
        font-size: 14px;
        color: #333;
      }
      &.is-checked {
        .el-checkbox__inner {
          background-color: #333;
          border-color: #333;
        }
        .el-checkbox__label {
          color: inherit;
        }
      }
      .el-checkbox__input.is-focus {
        .el-checkbox__inner {
          border-color: #333;
        }
      }
    }
  }

  .creative-module {
    .tips {
      margin-top: 12px;
      line-height: 20px;
      font-size: 12px;
      color: #333;
      .el-icon-info {
        margin-right: 5px;
        font-size: 16px;
        color: #969696;
        vertical-align: -2px;
      }
    }
    .switch-bottom {
      margin-top: 32px;
      .title-name {
        margin-bottom: 12px;
        font-weight: 600;
        color: #333;
        line-height: 22px;
      }
    }
  }
  .creative-preview {
    position: absolute;
    top: 32px;
    right: 0px;
    width: 310px;
    height: 561px;
    padding: 24px;
    background-color: #fff;
    border: 1px solid #e3e3e4;
    border-radius: 2px;
    .title-section {
      margin-bottom: 21px;
      overflow: hidden;
      .title-text {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #1f1f1f;
        display: inline-block;
      }
      .change-arrow {
        float: right;
        .icon {
          font-size: 20px;
          font-weight: bold;
          color: #999;
          cursor: not-allowed;
          &.mr {
            margin-right: 27px;
          }
        }
      }
    }
    .component-preview-wrapper {
      position: relative;
      width: 264px;
      height: 468px;
      border-radius: 10px;
      border: 1px solid #ebebeb;
      overflow: hidden;
      .live {
        width: 100%;
        height: 100%;
        background-image: url("../../../../assets/images/simulation/live_bg.png");
        background-size: 100% 100%;
        .creative-detail-info {
          position: absolute;
          left: 17px;
          right: 0;
          bottom: 55px;
          overflow: hidden;
          .avatar {
            float: left;
            width: 39px;
            height: 39px;
            border-radius: 50%;
          }
          .account-name {
            float: left;
            margin-left: 10px;
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            color: #fff;
          }
        }
      }
      .video {
        .not-support {
          padding-top: 160px;
          text-align: center;
          .empty-text {
            margin-top: 8px;
            font-size: 12px;
            line-height: 17px;
            color: #999;
          }
        }
      }
    }
  }
  .live-show-promise-notice {
    padding-top: 28px;
    ::v-deep .el-checkbox {
      .el-checkbox__inner {
        width: 16px;
        height: 16px;
        &::after {
          top: 2px;
          left: 5px;
        }
      }
      .el-checkbox__input.is-disabled.is-checked {
        .el-checkbox__inner {
          background-color: #c1c1c1;
          border-color: #c1c1c1;
          &::after {
            border-color: #fff;
          }
        }
      }
    }
    span {
      margin-left: 5px;
      vertical-align: middle;
    }
    a {
      color: #194ce5;
    }
  }
}
</style>